import { booleanAttribute, Component, Input } from '@angular/core';
import { CurrencyPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CompactAmountPipe } from '../../pipe/compact-amount.pipe';

@Component({
  selector: 'app-tender-amount',
  standalone: true,
  imports: [CurrencyPipe, TranslateModule, NgClass, NgTemplateOutlet, CompactAmountPipe],
  templateUrl: './tender-amount.component.html',
  styleUrl: './tender-amount.component.scss',
})
export class TenderAmountComponent {
  @Input() amount?: { min: number; max: number; total: number };
  @Input() undetectedTranslationKey = 'not-detected-amount';
  @Input() stylingClass: 'regular' | 'light' = 'regular';
  @Input({ transform: booleanAttribute }) compactVersion = false;
  @Input({ transform: booleanAttribute }) largeFont = false;
}
